<template>
  <div>
    <div class="language">
      <span
        class="left"
        :class="{ opacity3: $i18n.locale === 'en' }"
        @click="langChange('zh')"
        >中文</span
      >
      <span class="border">/</span>
      <span
        class="right"
        :class="{ opacity3: $i18n.locale === 'zh' }"
        @click="langChange('en')"
        >EN</span
      >
    </div>
    <van-popup v-model="show" position="bottom" :overlay="false" round>
      <div class="form-box">
        <div
          class="form-header"
          v-text="$t3('忘记密码', 'Forgot Passowrd')"
        ></div>
        <div class="form-body">
          <van-form @submit="pasSubmit" v-if="!setPas">
            <div class="pas-input">
              <van-field
                v-model="form.account"
                name="邮箱"
                :placeholder="$t('mailbox')"
                :rules="[{ required: true, message: $t('input.emailTip') }]"
              >
                <template #button>
                  <van-button
                    class="code-button"
                    size="small"
                    @click="sendCode"
                    v-if="!timerLoading"
                    >{{ $t("code") }}</van-button
                  >
                  <van-button
                    class="code-button"
                    size="small"
                    style="pointer-events: none"
                    v-else
                    >{{ time + "s" }}</van-button
                  >
                </template>
              </van-field>
            </div>
            <div class="pas-input">
              <van-field
                v-model="form.code"
                name="验证码"
                :placeholder="$t('code')"
                :rules="[{ required: true, message: $t('input.codeTip') }]"
              />
            </div>
            <van-button
              class="submit-button"
              round
              block
              type="info"
              native-type="submit"
              >{{ $t("submit") }}</van-button
            >
          </van-form>
          <van-form @submit="setPasSubmit" v-else>
            <div class="pas-input">
              <van-field
                v-model="form.password"
                name="密码"
                :placeholder="$t('newPasword')"
                :rules="[{ required: true, message: $t('input.pasTip') }]"
              />
            </div>
            <div class="pas-input">
              <van-field
                v-model="form.rePassword"
                name="新密码"
                :placeholder="$t('newPasword1')"
                :rules="[
                  { validator: checkPassword, message: checkPasswordMessage },
                ]"
              />
            </div>
            <van-button
              class="submit-button"
              round
              block
              type="info"
              native-type="submit"
              >{{ $t("submit") }}</van-button
            >
          </van-form>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { sendEmail, sendSms } from "@/api/kaptcha";
import { checkCode, resetGuest, resetMedia, resetWorker, resetGuangzhou } from "@/api/login";

const tmpForm = {
  conferenceId: undefined,
  account: undefined,
  code: undefined,
  password: undefined,
  rePassword: undefined,
};

export default {
  name: "setPassword",
  data() {
    return {
      form: Object.assign({}, tmpForm),
      setPas: false,
      show: true,
      title: "forgotPas",
      conferenceId: this.$route.params.conferenceId,
      type: this.$route.params.type,
      sendFormLoading: false,
      resetFormLoading: false,
      initTime: 60,
      time: undefined,
      timerLoading: false,
    };
  },
  methods: {
    sendCode() {
      if (!this.sendFormLoading) {
        this.sendFormLoading = true;
        if (/^1\d{10}$/.test(this.form.account)) {
          if (this.type !== "GT") {
            this.sendFormLoading = false;
            this.$notify({
              type: "warning",
              message: this.$t("input.accountIncorrect"),
            });
            return;
          }
          this.startTimer(() => {
            sendSms({ account: this.form.account }).then(
              () => (this.sendFormLoading = false),
              () => (this.sendFormLoading = false)
            );
          });
        } else if (
          /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/.test(
            this.form.account
          )
        ) {
          this.startTimer(() => {
            sendEmail({ account: this.form.account }).then(
              () => (this.sendFormLoading = false),
              () => (this.sendFormLoading = false)
            );
          });
        } else {
          this.sendFormLoading = false;
          this.$notify({
            type: "warning",
            message: this.$t("input.accountIncorrect"),
          });
        }
      }
    },
    startTimer(fun) {
      if (!this.timerLoading) {
        this.timerLoading = true;
        this.time = this.initTime;
        fun && fun();
        const timer = setInterval(() => {
          if (this.time-- <= 1) {
            this.timerLoading = false;
            clearInterval(timer);
          }
        }, 1000);
      }
    },
    pasSubmit() {
      if (!this.formLoading) {
        this.formLoading = true;
        const data = Object.assign({}, this.form);
        delete data.conferenceId;
        delete data.password;
        delete data.rePassword;
        checkCode(data).then(
          (res) => {
            if (res.success) {
              this.setPas = true;
              this.title = "setPas";
            }
            this.formLoading = false;
          },
          () => {
            this.formLoading = false;
          }
        );
      }
    },
    checkPassword() {
      if (!this.form.rePassword || this.form.rePassword === "") {
        return false;
      }
      if (this.form.password === this.form.rePassword) {
        return true;
      }
      return false;
    },
    checkPasswordMessage() {
      if (!this.form.rePassword || this.form.rePassword === "") {
        return this.$t("input.pasTip");
      }
      if (this.form.password === this.form.rePassword) {
        return true;
      }
      return this.$t("input.notSame");
    },
    setPasSubmit() {
      if (!this.resetFormLoading) {
        this.resetFormLoading = true;
        const data = Object.assign({}, this.form);
        data.conferenceId = this.conferenceId;
        delete data.code;
        delete data.rePassword;
        if (this.type === "GT") {
          resetGuest(data).then(
            (res) => {
              if (res.success) {
                this.$router.push("login");
              }
              this.resetFormLoading = false;
            },
            () => {
              this.resetFormLoading = false;
            }
          );
        } else if (this.type === "MT") {
          resetMedia(data).then(
            (res) => {
              if (res.success) {
                this.$router.push("login");
              }
              this.resetFormLoading = false;
            },
            () => {
              this.resetFormLoading = false;
            }
          );
        } else if (this.type === "WK") {
          resetWorker(data).then(
            (res) => {
              if (res.success) {
                this.$router.push("login");
              }
              this.resetFormLoading = false;
            },
            () => {
              this.resetFormLoading = false;
            }
          );
        } else if (this.type === "GZ") {
          resetGuangzhou(data).then(
            (res) => {
              if (res.success) {
                this.$router.push("login");
              }
              this.resetFormLoading = false;
            },
            () => {
              this.resetFormLoading = false;
            }
          );
        }
      }
    },
    langChange(lang) {
      this.$changeLocale(lang);
    },
  },
};
</script>

<style lang="scss" scoped>
.language {
  position: absolute;
  top: 20px;
  right: 22px;
  font-size: 12px;
  font-family: SourceHanSansSC-Regular, SourceHanSansSC;
  font-weight: 400;
  color: #fff;
  display: flex;

  .left,
  .right {
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
  }
  .left {
    margin-right: 4px;
  }
  .right {
    margin-left: 4px;
  }

  .border {
    font-size: 10px;
    color: rgba($color: #fff, $alpha: 0.5);
    font-weight: 400;
  }

  span.opacity3 {
    color: rgba($color: #fff, $alpha: 0.5);
  }
}
.form-box {
  margin: 101px 0 0 !important;
}
</style>
